import axios from "axios";
import {
  // appUrl,
  apiMethods
} from "./apiConfig";

export const appUrl = "../../../acc-api/public/";
// export const appUrl = "../../../acc-api/";
// export const appUrl = "http://127.0.0.1:8000/";
// export const appUrl = "http://192.168.1.4:8000/";
// export const appUrl = "http://pharma.accurate-egypt.com/acc-api/public/";

function getHeader() {
  var token = JSON.parse(localStorage.getItem("token"));
  var header = {
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data"
    }
  };
  return header;
}

//reset password routes
export function login(formData) {
  return axios.post(appUrl + apiMethods.login, formData);
}
export function login_client(formData) {
  return axios.post(appUrl + apiMethods.login_client, formData);
}
export function check_auth(formData) {
  return axios.post(appUrl + apiMethods.check_auth, formData, getHeader());
}
export function get_permissions(formData) {
  return axios.post(appUrl + apiMethods.get_permissions, formData, getHeader());
}
export function logout() {
  return axios.post(appUrl + apiMethods.logout);
}
export function log_me(frmData) {
  return axios.post(appUrl + apiMethods.log_me, frmData, getHeader());
}
export function see_notify(frmData) {
  return axios.post(appUrl + apiMethods.see_notify, frmData, getHeader());
}
export function see_sms(frmData) {
  return axios.post(appUrl + apiMethods.see_sms, frmData, getHeader());
}
export function notification_sms(frmData) {
  return axios.post(appUrl + apiMethods.notification_sms, frmData, getHeader());
}
export function logs_not_seen(frmData) {
  return axios.post(appUrl + apiMethods.logs_not_seen, frmData, getHeader());
}
export function logs_not_sent(frmData) {
  return axios.post(appUrl + apiMethods.logs_not_sent, frmData, getHeader());
}
export function sms_not_seen(frmData) {
  return axios.post(appUrl + apiMethods.sms_not_seen, frmData, getHeader());
}
export function mohafzas() {
  return axios.get(appUrl + apiMethods.mohafzas, getHeader());
}
export function client_types() {
  return axios.get(appUrl + apiMethods.client_types, getHeader());
}
export function cities(id) {
  return axios.get(appUrl + apiMethods.cities + "/" + id, getHeader());
}
export function orders_only_page() {
  return axios.get(appUrl + apiMethods.orders_only_page, getHeader());
}
export function orders_and_fatwora_page() {
  return axios.get(appUrl + apiMethods.orders_and_fatwora_page, getHeader());
}
export function jobs() {
  return axios.get(appUrl + apiMethods.jobs, getHeader());
}
export function add_job(frmData) {
  return axios.post(appUrl + apiMethods.add_job, frmData, getHeader());
}
export function update_job(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_job + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_job(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_job + "/" + id,
    frmData,
    getHeader()
  );
}
export function client_classes() {
  return axios.get(appUrl + apiMethods.client_classes, getHeader());
}
export function add_client_class(frmData) {
  return axios.post(appUrl + apiMethods.add_client_class, frmData, getHeader());
}
export function update_client_class(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_client_class + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_client_class(id) {
  return axios.get(
    appUrl + apiMethods.delete_client_class + "/" + id,
    getHeader()
  );
}
export function item_price_layeres() {
  return axios.get(appUrl + apiMethods.item_price_layeres, getHeader());
}
export function add_item_price_layer(frmData) {
  return axios.post(
    appUrl + apiMethods.add_item_price_layer,
    frmData,
    getHeader()
  );
}
export function update_item_price_layer(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_item_price_layer + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_item_price_layer(id) {
  return axios.get(
    appUrl + apiMethods.delete_item_price_layer + "/" + id,
    getHeader()
  );
}
export function offer_items() {
  return axios.get(appUrl + apiMethods.offer_items, getHeader());
}
export function add_offer_item(frmData) {
  return axios.post(appUrl + apiMethods.add_offer_item, frmData, getHeader());
}
export function update_offer_item(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_offer_item + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_offer_item(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_offer_item + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_transfer_fatwora(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_transfer_fatwora + "/" + id,
    frmData,
    getHeader()
  );
}
export function regions() {
  return axios.get(appUrl + apiMethods.regions, getHeader());
}
export function add_region(frmData) {
  return axios.post(appUrl + apiMethods.add_region, frmData, getHeader());
}
export function update_region(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_region + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_region(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_region + "/" + id,
    frmData,
    getHeader()
  );
}
export function moneys() {
  return axios.get(appUrl + apiMethods.moneys, getHeader());
}
export function add_money(frmData) {
  return axios.post(appUrl + apiMethods.add_money, frmData, getHeader());
}
export function update_money(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_money + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_money(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_money + "/" + id,
    frmData,
    getHeader()
  );
}

export function users() {
  return axios.get(appUrl + apiMethods.users, getHeader());
}
export function user(id) {
  return axios.get(appUrl + apiMethods.user + "/" + id, getHeader());
}
export function reset_user_password(id) {
  return axios.get(
    appUrl + apiMethods.reset_user_password + "/" + id,
    getHeader()
  );
}
export function add_user(frmData) {
  return axios.post(appUrl + apiMethods.add_user, frmData, getHeader());
}
export function update_user(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_user + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_user(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_user + "/" + id,
    frmData,
    getHeader()
  );
}

export function client_users() {
  return axios.get(appUrl + apiMethods.client_users, getHeader());
}
export function add_client_user(frmData) {
  return axios.post(appUrl + apiMethods.add_client_user, frmData, getHeader());
}
export function update_client_user(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_client_user + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_client_user(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_client_user + "/" + id,
    frmData,
    getHeader()
  );
}

export function mandob_targets(id) {
  return axios.get(appUrl + apiMethods.mandob_targets + "/" + id, getHeader());
}
export function add_mandob_targets(frmData) {
  return axios.post(
    appUrl + apiMethods.add_mandob_targets,
    frmData,
    getHeader()
  );
}
export function update_mandob_targets(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_mandob_targets + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_mandob_targets(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_mandob_targets + "/" + id,
    frmData,
    getHeader()
  );
}
export function remove_item_from_target(id) {
  return axios.get(
    appUrl + apiMethods.remove_item_from_target + "/" + id,
    getHeader()
  );
}
export function confirm_order_from_super(frmData) {
  return axios.post(
    appUrl + apiMethods.confirm_order_from_super,
    frmData,
    getHeader()
  );
}
export function update_order_from_super(frmData) {
  return axios.post(
    appUrl + apiMethods.update_order_from_super,
    frmData,
    getHeader()
  );
}
export function delete_order_from_super(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_order_from_super + "/" + id,
    frmData,
    getHeader()
  );
}

export function employers() {
  return axios.get(appUrl + apiMethods.employers, getHeader());
}
export function mandobs() {
  return axios.get(appUrl + apiMethods.mandobs, getHeader());
}
export function employers_page() {
  return axios.get(appUrl + apiMethods.employers_page, getHeader());
}
export function employers_salary(frmData) {
  return axios.post(appUrl + apiMethods.employers_salary, frmData, getHeader());
}
export function add_employer(frmData) {
  return axios.post(appUrl + apiMethods.add_employer, frmData, getHeader());
}
export function update_employer(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_employer + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_employer(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_employer + "/" + id,
    frmData,
    getHeader()
  );
}

export function branches() {
  return axios.get(appUrl + apiMethods.branches, getHeader());
}
export function add_branch(frmData) {
  return axios.post(appUrl + apiMethods.add_branch, frmData, getHeader());
}
export function update_branch(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_branch + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_branch(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_branch + "/" + id,
    frmData,
    getHeader()
  );
}

export function clients() {
  return axios.get(appUrl + apiMethods.clients, getHeader());
}
export function clients_page() {
  return axios.get(appUrl + apiMethods.clients_page, getHeader());
}
export function upload_client_file(frmData) {
  return axios.post(
    appUrl + apiMethods.upload_client_file,
    frmData,
    getHeader()
  );
}
export function add_client(frmData) {
  return axios.post(appUrl + apiMethods.add_client, frmData, getHeader());
}
export function search_client_by_id(id) {
  return axios.get(appUrl + apiMethods.client + "/" + id, getHeader());
}
export function update_client(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_client + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_client(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_client + "/" + id,
    frmData,
    getHeader()
  );
}

export function importers() {
  return axios.get(appUrl + apiMethods.importers, getHeader());
}
export function add_importer(frmData) {
  return axios.post(appUrl + apiMethods.add_importer, frmData, getHeader());
}
export function update_importer(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_importer + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_importer(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_importer + "/" + id,
    frmData,
    getHeader()
  );
}

export function orders() {
  return axios.get(appUrl + apiMethods.orders, getHeader());
}
export function add_order(frmData) {
  return axios.post(appUrl + apiMethods.add_order, frmData, getHeader());
}
export function confirm_order(id) {
  return axios.get(appUrl + apiMethods.confirm_order + "/" + id, getHeader());
}
export function reject_order(id) {
  return axios.get(appUrl + apiMethods.reject_order + "/" + id, getHeader());
}

export function stores() {
  return axios.get(appUrl + apiMethods.stores, getHeader());
}
export function all_stores() {
  return axios.get(appUrl + apiMethods.all_stores, getHeader());
}
export function stores_of() {
  return axios.get(appUrl + apiMethods.stores_of, getHeader());
}
export function add_store(frmData) {
  return axios.post(appUrl + apiMethods.add_store, frmData, getHeader());
}
export function update_store(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_store + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_store(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_store + "/" + id,
    frmData,
    getHeader()
  );
}
export function groups() {
  return axios.get(appUrl + apiMethods.groups, getHeader());
}
export function add_group(frmData) {
  return axios.post(appUrl + apiMethods.add_group, frmData, getHeader());
}
export function update_group(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_group + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_group(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_group + "/" + id,
    frmData,
    getHeader()
  );
}
export function employer_hafezs() {
  return axios.get(appUrl + apiMethods.employer_hafezs, getHeader());
}
export function add_employer_hafez(frmData) {
  return axios.post(
    appUrl + apiMethods.add_employer_hafez,
    frmData,
    getHeader()
  );
}
export function update_employer_hafez(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_employer_hafez + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_employer_hafez(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_employer_hafez + "/" + id,
    frmData,
    getHeader()
  );
}
export function employer_khasms() {
  return axios.get(appUrl + apiMethods.employer_khasms, getHeader());
}
export function add_employer_khasm(frmData) {
  return axios.post(
    appUrl + apiMethods.add_employer_khasm,
    frmData,
    getHeader()
  );
}
export function update_employer_khasm(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_employer_khasm + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_employer_khasm(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_employer_khasm + "/" + id,
    frmData,
    getHeader()
  );
}
export function employer_badalats() {
  return axios.get(appUrl + apiMethods.employer_badalats, getHeader());
}
export function add_employer_badalat(frmData) {
  return axios.post(
    appUrl + apiMethods.add_employer_badalat,
    frmData,
    getHeader()
  );
}
export function update_employer_badalat(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_employer_badalat + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_employer_badalat(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_employer_badalat + "/" + id,
    frmData,
    getHeader()
  );
}
export function employer_solfas() {
  return axios.get(appUrl + apiMethods.employer_solfas, getHeader());
}
export function add_employer_solfa(frmData) {
  return axios.post(
    appUrl + apiMethods.add_employer_solfa,
    frmData,
    getHeader()
  );
}
export function update_employer_solfa(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_employer_solfa + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_employer_solfa(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_employer_solfa + "/" + id,
    frmData,
    getHeader()
  );
}
export function items() {
  return axios.get(appUrl + apiMethods.items, getHeader());
}
export function items_of(id) {
  return axios.get(appUrl + apiMethods.items_of + "/" + id, getHeader());
}
export function items_of_specific_order(id, frmData) {
  return axios.post(
    appUrl + apiMethods.items_of_specific_order + "/" + id,
    frmData,
    getHeader()
  );
}
export function add_item(frmData) {
  return axios.post(appUrl + apiMethods.add_item, frmData, getHeader());
}
export function update_item(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_item + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_item(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_item + "/" + id,
    frmData,
    getHeader()
  );
}
export function khazinas(id) {
  return axios.get(appUrl + apiMethods.khazinas + "/" + id, getHeader());
}
export function khazina(id) {
  return axios.get(appUrl + apiMethods.khazina + "/" + id, getHeader());
}
export function add_khazina(frmData) {
  return axios.post(appUrl + apiMethods.add_khazina, frmData, getHeader());
}
export function khazina_transfer_fatworas(frmData) {
  return axios.post(
    appUrl + apiMethods.khazina_transfer_fatworas,
    frmData,
    getHeader()
  );
}
export function update_khazina(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_khazina + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_khazina(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_khazina + "/" + id,
    frmData,
    getHeader()
  );
}
export function khazina_client_sadads(id) {
  return axios.get(
    appUrl + apiMethods.khazina_client_sadads + "/" + id,
    getHeader()
  );
}
export function khazina_importer_sadads(id) {
  return axios.get(
    appUrl + apiMethods.khazina_importer_sadads + "/" + id,
    getHeader()
  );
}
export function khazina_deposit_all(id) {
  return axios.get(
    appUrl + apiMethods.khazina_deposit_all + "/" + id,
    getHeader()
  );
}
export function khazina_withdrew_all(id) {
  return axios.get(
    appUrl + apiMethods.khazina_withdrew_all + "/" + id,
    getHeader()
  );
}
export function banks() {
  return axios.get(appUrl + apiMethods.banks, getHeader());
}
export function bank(id) {
  return axios.get(appUrl + apiMethods.bank + "/" + id, getHeader());
}
export function add_bank(frmData) {
  return axios.post(appUrl + apiMethods.add_bank, frmData, getHeader());
}
export function update_bank(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_bank + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_bank(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_bank + "/" + id,
    frmData,
    getHeader()
  );
}
export function ohdas() {
  return axios.get(appUrl + apiMethods.ohdas, getHeader());
}
export function add_ohda(frmData) {
  return axios.post(appUrl + apiMethods.add_ohda, frmData, getHeader());
}
export function add_tasfia(id) {
  return axios.get(appUrl + apiMethods.add_tasfia + "/" + id, getHeader());
}
export function update_ohda(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_ohda + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_ohda(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_ohda + "/" + id,
    frmData,
    getHeader()
  );
}
export function sadadtypes() {
  return axios.get(appUrl + apiMethods.sadadtypes, getHeader());
}
export function add_sadadtype(frmData) {
  return axios.post(appUrl + apiMethods.add_sadadtype, frmData, getHeader());
}
export function update_sadadtype(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_sadadtype + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_sadadtype(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_sadadtype + "/" + id,
    frmData,
    getHeader()
  );
}
export function importer_fatworas() {
  return axios.get(appUrl + apiMethods.importer_fatworas, getHeader());
}
export function importer_fatwora(id) {
  return axios.get(
    appUrl + apiMethods.importer_fatworas + "/" + id,
    getHeader()
  );
}
export function buy_fatwora(id) {
  return axios.get(appUrl + apiMethods.buy_fatwora + "/" + id, getHeader());
}
export function delete_buy_fatwora(id) {
  return axios.get(
    appUrl + apiMethods.delete_buy_fatwora + "/" + id,
    getHeader()
  );
}
export function remove_item_from_import_fatwora(id) {
  return axios.get(
    appUrl + apiMethods.remove_item_from_import_fatwora + "/" + id,
    getHeader()
  );
}
export function confirm_fatwora_buy(id) {
  return axios.get(
    appUrl + apiMethods.confirm_fatwora_buy + "/" + id,
    getHeader()
  );
}
export function reject_fatwora_buy(frmData, id) {
  return axios.post(
    appUrl + apiMethods.reject_fatwora_buy + "/" + id,
    frmData,
    getHeader()
  );
}
export function add_importer_fatwora(frmData) {
  return axios.post(
    appUrl + apiMethods.add_importer_fatwora,
    frmData,
    getHeader()
  );
}
export function update_importer_fatwora(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_importer_fatwora + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_importer_fatwora(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_importer_fatwora + "/" + id,
    frmData,
    getHeader()
  );
}

export function madionia_importer(id) {
  return axios.get(
    appUrl + apiMethods.madionia_importer + "/" + id,
    getHeader()
  );
}

export function madionia_client(id) {
  return axios.get(appUrl + apiMethods.madionia_client + "/" + id, getHeader());
}

export function search_importer_by_code(code) {
  return axios.get(
    appUrl + apiMethods.search_importer_by_code + "/" + code,
    getHeader()
  );
}

export function search_client_by_code(code) {
  return axios.get(
    appUrl + apiMethods.search_client_by_code + "/" + code,
    getHeader()
  );
}

export function get_all_client_info(id) {
  return axios.get(
    appUrl + apiMethods.get_all_client_info + "/" + id,
    getHeader()
  );
}

export function get_all_info_of_importer(id) {
  return axios.get(
    appUrl + apiMethods.get_all_info_of_importer + "/" + id,
    getHeader()
  );
}

export function search_fatwora_import_by_code(code) {
  return axios.get(
    appUrl + apiMethods.search_fatwora_import_by_code + "/" + code,
    getHeader()
  );
}

export function search_fatwora_client_by_code(code) {
  return axios.get(
    appUrl + apiMethods.search_fatwora_client_by_code + "/" + code,
    getHeader()
  );
}

export function importer_fatwora_rebacks(code) {
  return axios.get(
    appUrl + apiMethods.importer_fatwora_rebacks + "/" + code,
    getHeader()
  );
}
export function importer_fatwora_reback(id) {
  return axios.get(
    appUrl + apiMethods.importer_fatwora_reback + "/" + id,
    getHeader()
  );
}
export function add_importer_fatwora_reback(frmData) {
  return axios.post(
    appUrl + apiMethods.add_importer_fatwora_reback,
    frmData,
    getHeader()
  );
}

export function all_reback_fatworas() {
  return axios.get(appUrl + apiMethods.all_reback_fatworas, getHeader());
}

export function reback_fatworas(id) {
  return axios.get(appUrl + apiMethods.reback_fatworas + "/" + id, getHeader());
}

export function confirm_reback_fatwora(id, frmData) {
  return axios.post(
    appUrl + apiMethods.confirm_reback_fatwora + "/" + id,
    frmData,
    getHeader()
  );
}

export function client_fatwora_rebacks() {
  return axios.get(appUrl + apiMethods.client_fatwora_rebacks, getHeader());
}
export function client_fatwora_reback(id) {
  return axios.get(
    appUrl + apiMethods.client_fatwora_reback + "/" + id,
    getHeader()
  );
}
export function add_client_fatwora_reback(frmData) {
  return axios.post(
    appUrl + apiMethods.add_client_fatwora_reback,
    frmData,
    getHeader()
  );
}

export function fatworas() {
  return axios.get(appUrl + apiMethods.fatworas, getHeader());
}
export function fatwora_detail(id) {
  return axios.get(appUrl + apiMethods.fatwora_detail + "/" + id, getHeader());
}
export function fatwora_reback_detail(id, frmData) {
  return axios.post(
    appUrl + apiMethods.fatwora_reback_detail + "/" + id,
    frmData,
    getHeader()
  );
}
export function tanfiz_fatworas() {
  return axios.get(appUrl + apiMethods.tanfiz_fatworas, getHeader());
}
export function tanfiz_confirm(id, frmData) {
  return axios.post(
    appUrl + apiMethods.tanfiz_confirm + "/" + id,
    frmData,
    getHeader()
  );
}
export function taslim_fatworas() {
  return axios.get(appUrl + apiMethods.taslim_fatworas, getHeader());
}
export function taslim_confirm(id, frmData) {
  return axios.post(
    appUrl + apiMethods.taslim_confirm + "/" + id,
    frmData,
    getHeader()
  );
}
export function taslim_reject(id, frmData) {
  return axios.post(
    appUrl + apiMethods.taslim_reject + "/" + id,
    frmData,
    getHeader()
  );
}
export function solmt_fatworas() {
  return axios.get(appUrl + apiMethods.solmt_fatworas, getHeader());
}
export function solmt_confirm(id, frmData) {
  return axios.post(
    appUrl + apiMethods.solmt_confirm + "/" + id,
    frmData,
    getHeader()
  );
}
export function solmt_reject(id, frmData) {
  return axios.post(
    appUrl + apiMethods.solmt_reject + "/" + id,
    frmData,
    getHeader()
  );
}
export function sarf_from_store_fatworas(id) {
  return axios.get(
    appUrl + apiMethods.sarf_from_store_fatworas + "/" + id,
    getHeader()
  );
}
export function sarf_from_store_confirm(id, frmData) {
  return axios.post(
    appUrl + apiMethods.sarf_from_store_confirm + "/" + id,
    frmData,
    getHeader()
  );
}
export function sarf_from_store_reject(id, frmData) {
  return axios.post(
    appUrl + apiMethods.sarf_from_store_reject + "/" + id,
    frmData,
    getHeader()
  );
}
export function fatwora(id) {
  return axios.get(appUrl + apiMethods.fatwora + "/" + id, getHeader());
}
export function accept_fatwora(id) {
  return axios.get(appUrl + apiMethods.accept_fatwora + "/" + id, getHeader());
}
export function add_fatwora(frmData) {
  return axios.post(appUrl + apiMethods.add_fatwora, frmData, getHeader());
}
export function update_fatwora(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_fatwora + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_fatwora(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_fatwora + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_fatwora_client_before_store(id) {
  return axios.get(
    appUrl + apiMethods.delete_fatwora_client_before_store + "/" + id,
    getHeader()
  );
}

export function sadadstatuses() {
  return axios.get(appUrl + apiMethods.sadadstatuses, getHeader());
}
export function sadadstatus(id) {
  return axios.get(appUrl + apiMethods.sadadstatus + "/" + id, getHeader());
}
export function add_sadadstatus(frmData) {
  return axios.post(appUrl + apiMethods.add_sadadstatus, frmData, getHeader());
}
export function update_sadadstatus(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_sadadstatus + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_sadadstatus(frmData, id) {
  return axios.post(
    appUrl + apiMethods.delete_sadadstatus + "/" + id,
    frmData,
    getHeader()
  );
}
export function fatworas_transfer_from(id) {
  return axios.get(
    appUrl + apiMethods.fatworas_transfer_from + "/" + id,
    getHeader()
  );
}
export function fatworas_transfer_to(id) {
  return axios.get(
    appUrl + apiMethods.fatworas_transfer_to + "/" + id,
    getHeader()
  );
}
export function all_transfer_fatworas() {
  return axios.get(appUrl + apiMethods.all_transfer_fatworas, getHeader());
}
export function add_fatwora_transfer(frmData) {
  return axios.post(
    appUrl + apiMethods.add_fatwora_transfer,
    frmData,
    getHeader()
  );
}
export function update_fatwora_transfer(id, frmData) {
  return axios.post(
    appUrl + apiMethods.update_fatwora_transfer + "/" + id,
    frmData,
    getHeader()
  );
}
export function transfer_confirm(id, frmData) {
  return axios.post(
    appUrl + apiMethods.transfer_confirm + "/" + id,
    frmData,
    getHeader()
  );
}
export function transfer_reject(id, frmData) {
  return axios.post(
    appUrl + apiMethods.transfer_reject + "/" + id,
    frmData,
    getHeader()
  );
}
export function fatworas_client_no_sadad(id) {
  return axios.get(
    appUrl + apiMethods.fatworas_client_no_sadad + "/" + id,
    getHeader()
  );
}
export function fatworas_importer_no_sadad(id) {
  return axios.get(
    appUrl + apiMethods.fatworas_importer_no_sadad + "/" + id,
    getHeader()
  );
}
export function khazna_fatworas() {
  return axios.get(appUrl + apiMethods.khazna_fatworas, getHeader());
}
export function money_fatworas() {
  return axios.get(appUrl + apiMethods.money_fatworas, getHeader());
}
export function add_client_sadad(frmData) {
  return axios.post(appUrl + apiMethods.add_client_sadad, frmData, getHeader());
}
export function add_importer_sadad(frmData) {
  return axios.post(
    appUrl + apiMethods.add_importer_sadad,
    frmData,
    getHeader()
  );
}
export function add_client_khasm(frmData) {
  return axios.post(appUrl + apiMethods.add_client_khasm, frmData, getHeader());
}
export function add_cheque(frmData) {
  return axios.post(appUrl + apiMethods.add_cheque, frmData, getHeader());
}
export function update_cheque(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_cheque + "/" + id,
    frmData,
    getHeader()
  );
}
export function cheques() {
  return axios.get(appUrl + apiMethods.cheques, getHeader());
}
export function delete_cheque(id) {
  return axios.get(appUrl + apiMethods.delete_cheque + "/" + id, getHeader());
}
export function delete_client_khasm(id) {
  return axios.get(
    appUrl + apiMethods.delete_client_khasm + "/" + id,
    getHeader()
  );
}
export function delete_client_sadad(id) {
  return axios.get(
    appUrl + apiMethods.delete_client_sadad + "/" + id,
    getHeader()
  );
}
export function delete_importer_sadad(id) {
  return axios.get(
    appUrl + apiMethods.delete_importer_sadad + "/" + id,
    getHeader()
  );
}
export function delete_deposit_khazna(id) {
  return axios.get(
    appUrl + apiMethods.delete_deposit_khazna + "/" + id,
    getHeader()
  );
}
export function delete_masrof(id) {
  return axios.get(appUrl + apiMethods.delete_masrof + "/" + id, getHeader());
}
export function add_khasm_madionia(frmData) {
  return axios.post(
    appUrl + apiMethods.add_khasm_madionia,
    frmData,
    getHeader()
  );
}
export function add_deposit(frmData) {
  return axios.post(appUrl + apiMethods.add_deposit, frmData, getHeader());
}
export function add_withdrew(frmData) {
  return axios.post(appUrl + apiMethods.add_withdrew, frmData, getHeader());
}
export function add_khazinaTransfer(frmData) {
  return axios.post(
    appUrl + apiMethods.add_khazinaTransfer,
    frmData,
    getHeader()
  );
}
export function add_masrof(frmData) {
  return axios.post(appUrl + apiMethods.add_masrof, frmData, getHeader());
}
export function card_sanf(frmData) {
  return axios.post(appUrl + apiMethods.card_sanf, frmData, getHeader());
}
export function gardStore(id) {
  return axios.get(appUrl + apiMethods.gardStore + "/" + id, getHeader());
}
export function add_employer_store(frmData) {
  return axios.post(
    appUrl + apiMethods.add_employer_store,
    frmData,
    getHeader()
  );
}
export function add_start_item_quantity(frmData) {
  return axios.post(
    appUrl + apiMethods.add_start_item_quantity,
    frmData,
    getHeader()
  );
}
export function store_items_start(frmData) {
  return axios.post(
    appUrl + apiMethods.store_items_start,
    frmData,
    getHeader()
  );
}
export function employer_stores() {
  return axios.get(appUrl + apiMethods.employer_stores, getHeader());
}
export function delete_employer_store(id) {
  return axios.get(
    appUrl + apiMethods.delete_employer_store + "/" + id,
    getHeader()
  );
}
export function delete_start_item_quantity(id) {
  return axios.get(
    appUrl + apiMethods.delete_start_item_quantity + "/" + id,
    getHeader()
  );
}
export function bank_fatworas() {
  return axios.get(appUrl + apiMethods.bank_fatworas, getHeader());
}
export function add_bank_deposit(frmData) {
  return axios.post(appUrl + apiMethods.add_bank_deposit, frmData, getHeader());
}
export function add_bank_withdrew(frmData) {
  return axios.post(
    appUrl + apiMethods.add_bank_withdrew,
    frmData,
    getHeader()
  );
}
export function add_BankTransfer(frmData) {
  return axios.post(appUrl + apiMethods.add_BankTransfer, frmData, getHeader());
}
export function clienttypes() {
  return axios.get(appUrl + apiMethods.clienttypes, getHeader());
}
export function add_omola(frmData) {
  return axios.post(appUrl + apiMethods.add_omola, frmData, getHeader());
}
export function add_hafez(frmData) {
  return axios.post(appUrl + apiMethods.add_hafez, frmData, getHeader());
}
export function add_khasm(frmData) {
  return axios.post(appUrl + apiMethods.add_khasm, frmData, getHeader());
}
export function add_badalat(frmData) {
  return axios.post(appUrl + apiMethods.add_badalat, frmData, getHeader());
}
export function add_solfa(frmData) {
  return axios.post(appUrl + apiMethods.add_solfa, frmData, getHeader());
}
export function employers_vacation(frmData) {
  return axios.post(
    appUrl + apiMethods.employers_vacation,
    frmData,
    getHeader()
  );
}
export function add_agaza(frmData) {
  return axios.post(appUrl + apiMethods.add_agaza, frmData, getHeader());
}
export function add_absence(frmData) {
  return axios.post(appUrl + apiMethods.add_absence, frmData, getHeader());
}
export function ClientDetailAccount(frmData) {
  return axios.post(
    appUrl + apiMethods.ClientDetailAccount,
    frmData,
    getHeader()
  );
}
export function ClientAccount(frmData) {
  return axios.post(appUrl + apiMethods.ClientAccount, frmData, getHeader());
}
export function employers_attends(frmData) {
  return axios.post(
    appUrl + apiMethods.employers_attends,
    frmData,
    getHeader()
  );
}
export function add_come(frmData) {
  return axios.post(appUrl + apiMethods.add_come, frmData, getHeader());
}
export function add_go(frmData) {
  return axios.post(appUrl + apiMethods.add_go, frmData, getHeader());
}
export function change_password(frmData) {
  return axios.post(appUrl + apiMethods.change_password, frmData, getHeader());
}
export function ImporterAccount(frmData) {
  return axios.post(appUrl + apiMethods.ImporterAccount, frmData, getHeader());
}
export function FinalFatworas() {
  return axios.get(appUrl + apiMethods.FinalFatworas, getHeader());
}
export function new_clients() {
  return axios.get(appUrl + apiMethods.new_clients, getHeader());
}
export function confirm_new_client($id) {
  return axios.get(
    appUrl + apiMethods.confirm_new_client + "/" + $id,
    getHeader()
  );
}
export function mandobVisits(frmData) {
  return axios.post(appUrl + apiMethods.mandobVisits, frmData, getHeader());
}
export function mandobTasks(frmData) {
  return axios.post(appUrl + apiMethods.mandobTasks, frmData, getHeader());
}
export function addTask(frmData) {
  return axios.post(appUrl + apiMethods.addTask, frmData, getHeader());
}
export function delete_task(frmData) {
  return axios.post(appUrl + apiMethods.delete_task, frmData, getHeader());
}
export function tahsilat() {
  return axios.get(appUrl + apiMethods.tahsilat, getHeader());
}
export function confirm_tahsilat($id) {
  return axios.get(
    appUrl + apiMethods.confirm_tahsilat + "/" + $id,
    getHeader()
  );
}
export function delete_tahsil($id) {
  return axios.get(appUrl + apiMethods.delete_tahsil + "/" + $id, getHeader());
}
export function tracks(frmData) {
  return axios.post(appUrl + apiMethods.tracks, frmData, getHeader());
}

//reports
export function Attendreport(frmData) {
  return axios.post(appUrl + apiMethods.Attendreport, frmData, getHeader());
}
export function MandobClientTypeReport(frmData) {
  return axios.post(
    appUrl + apiMethods.MandobClientTypeReport,
    frmData,
    getHeader()
  );
}
export function MandobClientMadioniaReport(frmData) {
  return axios.post(
    appUrl + apiMethods.MandobClientMadioniaReport,
    frmData,
    getHeader()
  );
}
export function MandobItemReport(frmData) {
  return axios.post(appUrl + apiMethods.MandobItemReport, frmData, getHeader());
}
export function MandobSalesReport(frmData) {
  return axios.post(
    appUrl + apiMethods.MandobSalesReport,
    frmData,
    getHeader()
  );
}
export function TahsilatReport(frmData) {
  return axios.post(appUrl + apiMethods.TahsilatReport, frmData, getHeader());
}
export function TasksReport(frmData) {
  return axios.post(appUrl + apiMethods.TasksReport, frmData, getHeader());
}
export function ClientsWithBranch(frmData) {
  return axios.post(
    appUrl + apiMethods.ClientsWithBranch,
    frmData,
    getHeader()
  );
}
export function ClientsWithMandob(frmData) {
  return axios.post(
    appUrl + apiMethods.ClientsWithMandob,
    frmData,
    getHeader()
  );
}
export function ClientsWithNew(frmData) {
  return axios.post(appUrl + apiMethods.ClientsWithNew, frmData, getHeader());
}
export function ClientsWithRegion(frmData) {
  return axios.post(
    appUrl + apiMethods.ClientsWithRegion,
    frmData,
    getHeader()
  );
}
export function mandob_target(frmData) {
  return axios.post(appUrl + apiMethods.mandob_target, frmData, getHeader());
}
export function BranchSalesReport(frmData) {
  return axios.post(
    appUrl + apiMethods.BranchSalesReport,
    frmData,
    getHeader()
  );
}
export function BranchSalesReportAllDetail(frmData) {
  return axios.post(
    appUrl + apiMethods.BranchSalesReportAllDetail,
    frmData,
    getHeader()
  );
}
export function BranchMadioniaReport(frmData) {
  return axios.post(
    appUrl + apiMethods.BranchMadioniaReport,
    frmData,
    getHeader()
  );
}
export function CompanyMadioniaReport(frmData) {
  return axios.post(
    appUrl + apiMethods.CompanyMadioniaReport,
    frmData,
    getHeader()
  );
}
export function CompanySalesReport(frmData) {
  return axios.post(
    appUrl + apiMethods.CompanySalesReport,
    frmData,
    getHeader()
  );
}
export function ItemSalesReport(frmData) {
  return axios.post(appUrl + apiMethods.ItemSalesReport, frmData, getHeader());
}
export function ItemBuyReport(frmData) {
  return axios.post(appUrl + apiMethods.ItemBuyReport, frmData, getHeader());
}
export function ItemClientTypeReport(frmData) {
  return axios.post(
    appUrl + apiMethods.ItemClientTypeReport,
    frmData,
    getHeader()
  );
}
export function AllVisitsSuper() {
  return axios.get(appUrl + apiMethods.AllVisitsSuper, getHeader());
}
export function MandobClientSadadReport(frmData) {
  return axios.post(
    appUrl + apiMethods.MandobClientSadadReport,
    frmData,
    getHeader()
  );
}
export function StoreItemTransferReport(frmData) {
  return axios.post(
    appUrl + apiMethods.StoreItemTransferReport,
    frmData,
    getHeader()
  );
}
export function StoreOneItemTransferReport(frmData) {
  return axios.post(
    appUrl + apiMethods.StoreOneItemTransferReport,
    frmData,
    getHeader()
  );
}
export function StoreGardDetailReport(frmData) {
  return axios.post(
    appUrl + apiMethods.StoreGardDetailReport,
    frmData,
    getHeader()
  );
}
export function ClientSadadReport(frmData) {
  return axios.post(
    appUrl + apiMethods.ClientSadadReport,
    frmData,
    getHeader()
  );
}
export function KhazinaInputReport(frmData) {
  return axios.post(
    appUrl + apiMethods.KhazinaInputReport,
    frmData,
    getHeader()
  );
}
export function KhazinaInputDetailReport(frmData) {
  return axios.post(
    appUrl + apiMethods.KhazinaInputDetailReport,
    frmData,
    getHeader()
  );
}
export function KhazinaImporterSadadReport(frmData) {
  return axios.post(
    appUrl + apiMethods.KhazinaImporterSadadReport,
    frmData,
    getHeader()
  );
}
export function EmployerSalaryReport(frmData) {
  return axios.post(
    appUrl + apiMethods.EmployerSalaryReport,
    frmData,
    getHeader()
  );
}
export function EmployerOmolaReport(frmData) {
  return axios.post(
    appUrl + apiMethods.EmployerOmolaReport,
    frmData,
    getHeader()
  );
}
export function RebackClientReport(frmData) {
  return axios.post(
    appUrl + apiMethods.RebackClientReport,
    frmData,
    getHeader()
  );
}
export function RebackMandobReport(frmData) {
  return axios.post(
    appUrl + apiMethods.RebackMandobReport,
    frmData,
    getHeader()
  );
}
export function RebackItemReport(frmData) {
  return axios.post(appUrl + apiMethods.RebackItemReport, frmData, getHeader());
}
export function RebackItemBuyReport(frmData) {
  return axios.post(
    appUrl + apiMethods.RebackItemBuyReport,
    frmData,
    getHeader()
  );
}
export function RebackImporterReport(frmData) {
  return axios.post(
    appUrl + apiMethods.RebackImporterReport,
    frmData,
    getHeader()
  );
}
export function MasrofAllReport(frmData) {
  return axios.post(appUrl + apiMethods.MasrofAllReport, frmData, getHeader());
}
export function MasrofWithTypeReport(frmData) {
  return axios.post(
    appUrl + apiMethods.MasrofWithTypeReport,
    frmData,
    getHeader()
  );
}
export function RebackSellAll(frmData) {
  return axios.post(appUrl + apiMethods.RebackSellAll, frmData, getHeader());
}
export function RebackSellAllByFatwora(frmData) {
  return axios.post(
    appUrl + apiMethods.RebackSellAllByFatwora,
    frmData,
    getHeader()
  );
}
export function RebackBuyAll(frmData) {
  return axios.post(appUrl + apiMethods.RebackBuyAll, frmData, getHeader());
}
export function StoreMovementReport(frmData) {
  return axios.post(
    appUrl + apiMethods.StoreMovementReport,
    frmData,
    getHeader()
  );
}
export function StoreMovementAllReport(frmData) {
  return axios.post(
    appUrl + apiMethods.StoreMovementAllReport,
    frmData,
    getHeader()
  );
}
export function ItemSalesAverageReport(frmData) {
  return axios.post(
    appUrl + apiMethods.ItemSalesAverageReport,
    frmData,
    getHeader()
  );
}
export function ClientSalesValueReport(frmData) {
  return axios.post(
    appUrl + apiMethods.ClientSalesValueReport,
    frmData,
    getHeader()
  );
}
export function ClientSadadSalesAverageReport(frmData) {
  return axios.post(
    appUrl + apiMethods.ClientSadadSalesAverageReport,
    frmData,
    getHeader()
  );
}
export function solmt_fatworas_mandob() {
  return axios.get(appUrl + apiMethods.solmt_fatworas_mandob, getHeader());
}
export function recent_orders_mandob() {
  return axios.get(appUrl + apiMethods.recent_orders_mandob, getHeader());
}
export function getloactions() {
  return axios.get(appUrl + apiMethods.getloactions, getHeader());
}
export function users_chat() {
  return axios.get(appUrl + apiMethods.users_chat, getHeader());
}
export function get_chat(frmData) {
  return axios.post(appUrl + apiMethods.get_chat, frmData, getHeader());
}
export function add_new_message(frmData) {
  return axios.post(appUrl + apiMethods.add_new_message, frmData, getHeader());
}
export function user_behavior(frmData) {
  return axios.post(appUrl + apiMethods.user_behavior, frmData, getHeader());
}
export function profit(frmData) {
  return axios.post(appUrl + apiMethods.profit, frmData, getHeader());
}
export function profit_items(frmData) {
  return axios.post(appUrl + apiMethods.profit_items, frmData, getHeader());
}
export function makhzon_cost(frmData) {
  return axios.post(appUrl + apiMethods.makhzon_cost, frmData, getHeader());
}
export function tax_fatworas() {
  return axios.get(appUrl + apiMethods.tax_fatworas, getHeader());
}
export function add_tax_fatwora(frmData) {
  return axios.post(appUrl + apiMethods.add_tax_fatwora, frmData, getHeader());
}
export function delete_tax_fatwora(id) {
  return axios.get(
    appUrl + apiMethods.delete_tax_fatwora + "/" + id,
    getHeader()
  );
}
export function delete_reback_fatwora(id) {
  return axios.get(
    appUrl + apiMethods.delete_reback_fatwora + "/" + id,
    getHeader()
  );
}
export function click_event() {
  return axios.get(appUrl + apiMethods.click_event, getHeader());
}

export function track_serials(frmData) {
  return axios.post(appUrl + apiMethods.track_serials, frmData, getHeader());
}
export function get_last_serials(id) {
  return axios.get(appUrl + apiMethods.get_last_serials + '/' + id, getHeader());
}

export function serials() {
  return axios.get(appUrl + apiMethods.serials, getHeader());
}
export function add_serial(frmData) {
  return axios.post(appUrl + apiMethods.add_serial, frmData, getHeader());
}
export function update_serial(frmData, id) {
  return axios.post(
    appUrl + apiMethods.update_serial + "/" + id,
    frmData,
    getHeader()
  );
}
export function delete_serial(id) {
  return axios.get(appUrl + apiMethods.delete_serial + "/" + id, getHeader());
}
